<h2 mat-dialog-title>Youtube Solution</h2>
<mat-dialog-content class="mat-typography">
  <iframe width="560" height="315" [src]="data.youtube | safe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

 
</mat-dialog-content>
